import { ReactNode, useState } from 'react'

import { Box, Tooltip } from '@factorialco/deprecated-design-system'

interface Props {
  identifier: string | number
  tooltipContent: ReactNode
  logoUrl: string
}

export const PremiumOfferAvatar = ({ identifier, tooltipContent, logoUrl }: Props) => {
  const [tooltipOpen, setTooltipOpen] = useState<boolean>(false)

  return (
    <Tooltip.Dialog
      key={`premium-offer-avatar-tooltip-${identifier}`}
      open={tooltipOpen}
      attachment="top center"
      backgroundColor="grey1000"
      size="big"
      textAlign="left"
      paddingY="s6"
      paddingX="s8"
      label={tooltipContent}
    >
      <Box
        onMouseEnter={() => setTooltipOpen(true)}
        onMouseLeave={() => setTooltipOpen(false)}
        border={{ all: { width: 's1', color: 'grey400', style: 'solid' } }}
        borderRadius={{ all: 'rel1000' }}
        width="s40"
        height="s40"
        overflowY="hidden"
        overflowX="hidden"
      >
        <img
          src={logoUrl}
          alt={identifier.toString()}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
      </Box>
    </Tooltip.Dialog>
  )
}
